if(!customElements.get('featured-products')) {
  customElements.define(
    'featured-products',
    class FeaturedProducts extends HTMLElement {
      #sliderEl = undefined;
      #sliderInstance = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#sliderEl = this.querySelector('[data-slider]');
        this.mount();
      }

      mount() {
        if(!this.#sliderEl) {
          return console.error('feautred-products: missing required components');
        }

        this.#sliderInstance = new Swiper(this.#sliderEl, {
          slidesPerView: 1.2,
          spaceBetween: 8,
          breakpoints: {
            768: {
              slidesPerView: 2
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 16
            }
          }
        });
      }

      get slider() {
        return this.#sliderInstance;
      }
    }
  );
}
